export const speechRecognitionLanguages = {
  'af': 'Afrikaans',
  'eu': 'Basque',
  'bg': 'Bulgarian',
  'ca': 'Catalan',
  'ar-MA': 'Arabic (Morocco)',
  'cs': 'Czech',
  'nl-NL': 'Dutch',
  'en-GB': 'English (UK)',
  'en-US': 'English (US)',
  'fi': 'Finnish',
  'fr-FR': 'French',
  'gl': 'Galician',
  'de-DE': 'German',
  'el-GR': 'Greek',
  'he': 'Hebrew',
  'hu': 'Hungarian',
  'is': 'Icelandic',
  'it-IT': 'Italian',
  'id': 'Indonesian',
  'ja': 'Japanese',
  'ko': 'Korean',
  'la': 'Latin',
  'zh-CN': 'Mandarin Chinese',
  'zh-TW': 'Taiwanese',
  'zh-HK': 'Cantonese',
  'ms-MY': 'Malaysian',
  'no-NO': 'Norwegian',
  'pl': 'Polish',
  'pt-PT': 'Portuguese',
  'pt-BR': 'Portuguese (Brasil)',
  'ro-RO': 'Romanian',
  'sr-SP': 'Serbian',
  'sk': 'Slovak',
  'es-ES': 'Spanish (Spain)',
  'sv-SE': 'Swedish',
  'tr': 'Turkish',
  'zu': 'Zulu'
} as const;